<article class="kanban-card" (click)="onCardClick($event)">
  <div class="card-header">
    <div class="card-title">
      <h3>{{ card().title }}</h3>
    </div>
  </div>

  <div class="card-fields">
    @if (!!card().assignedTo) {
      <div class="field-info">
        <strong class="field-label">Responsável:</strong>
        <span class="field-value">{{ card().assignedTo?.name }}</span>
      </div>
    }
    @if (card().shopId) {
      <div class="field-info">
        <strong class="field-label">Loja:</strong>
        <span class="field-value">{{ card().shopName }}</span>
      </div>
    }
    @if (card().cameraId) {
      <div class="field-info">
        <strong class="field-label">Câmera:</strong>
        <span class="field-value">{{ card().cameraName }}</span>
      </div>
    }
    @for (field of visibleCardFields(); track field.id) {
      <div class="field-info">
        <strong class="field-label">{{ field.label }}:</strong>
        <span class="field-value">{{ field.value || '-' }}</span>
      </div>
    }
  </div>

  <hr />

  <div class="card-tags">
    @for (tag of tags(); track tag) {
      <span class="chip">
        {{ tag.label || tag.id }}
        @if (tag.canRemove) {
          <button
            class="chip-close"
            (click)="onTagRemoved(tag.id); $event.stopPropagation()"
          >&times;</button>
        }
      </span>
    }
    @if (showAddTag()) {
      <select
        (change)="onTagSelected($event); $event.stopPropagation()"
        (click)="$event.stopPropagation()"
      >
        <option value="" disabled selected>Adicionar tag...</option>
        @for (tag of availableTags(); track tag.value) {
          <option [value]="tag.value">{{ tag.label }}</option>
        }
      </select>
    }
  </div>

  @if (actionsConfig()) {
    <div class="card-footer" (click)="$event.stopPropagation()">
      <div class="card-footer-left">
        @if (phaseHasForm()) {
          <div class="icon-action-wrapper" [class.has-badge]="isFormPending()">
            <button
              class="btn-icon"
              title="Preencher formulário"
              (click)="openPhaseForm.emit(card()); $event.stopPropagation()"
            >
              <span class="material-icons">assignment</span>
            </button>
          </div>
        }
      </div>
      <div class="card-footer-right">
        @if (actionsConfig()?.secondary && actionsConfig()!.secondary!.isAllowed !== false) {
          <button
            class="btn btn-text"
            (click)="actionsConfig()!.secondary!.onClick(card())"
          >{{ actionsConfig()!.secondary!.label }}</button>
        }
        @if (actionsConfig()?.primary && actionsConfig()!.primary!.isAllowed !== false) {
          <button
            class="btn btn-filled"
            (click)="actionsConfig()!.primary!.onClick(card())"
          >{{ actionsConfig()!.primary!.label }}</button>
        }
        @if (dropdownActions().length) {
          <div class="more-actions-container relative">
            <button
              class="btn-icon"
              (click)="toggleMoreActions($event)"
            >&#8942;</button>
            @if (showMoreActions) {
              <ul class="actions-menu">
                @for (action of dropdownActions(); track action.item) {
                  <li>
                    <button
                      [disabled]="action.disabled || false"
                      (click)="onDropdownActionClick(action)"
                    >{{ action.item }}</button>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    </div>
  }
</article>
